import { render, staticRenderFns } from "./PartsOrderPage.vue?vue&type=template&id=95fb831e&"
import script from "./PartsOrderPage.vue?vue&type=script&lang=js&"
export * from "./PartsOrderPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports